<template>
  <v-row justify="center">
    <v-dialog
      v-model="modalEnabled"
      persistent
      max-width="720"
    >
      <v-card class="elevation-4">
        <v-card-title>
          <span class="headline">{{ getTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-alert
            border="top"
            colored-border
            type="info"
            elevation="2"
          >
            <span style="color: gray">
              Внимание! Если изменение адреса объекта повлечет изменение населенного пункта или региона, убедитесь,
              что в вакансиях, по которым создаются офферы на данном объекте, заведены необходимые региональные ставки.
            </span>
          </v-alert>
          <v-row class="mt-6">
            <v-col
              v-if="getOriginalAddress"
              cols="12"
              class="px-3 py-3"
              :sm="12"
            >
              <v-textarea
                :value="getOriginalAddress"
                outlined
                label="Полученный адрес"
                readonly
                rows="2"
              />
            </v-col>
            <v-col
              v-if="getCurrentAddress"
              cols="12"
              class="px-3 py-3"
              :sm="12"
            >
              <v-textarea
                :value="getCurrentAddress"
                outlined
                label="Текущий адрес"
                readonly
                rows="2"
              />
            </v-col>
            <v-col
              cols="12"
              class="px-3 py-3"
              :sm="12"
            >
              <v-divider />
            </v-col>
            <v-col
              cols="12"
              :sm="12"
              class="py-0 my-0 mb-2"
            >
              <WBDAutocompleteSearch
                :model-type="modelTypeSet.MODEL_TYPE_ADDRESS"
                :value="getAddressSearchValue"
                :item-value="'id'"
                :item-text="'fullAddress'"
                :error="addressError"
                hide-details
                sync
                :label="'Поиск по полному адресу включая номер дома'"
                :placeholder="'Поиск по полному адресу включая номер дома'"
                @wbdAutoCompleteSelected="onAddressChange"
              />
            </v-col>
          </v-row>
          <WbdVerticalLoader v-if="requesting" />
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="warning"
            text
            @click="close"
          >
            Закрыть
          </v-btn>
          <v-spacer />
          <v-btn
            :color="'success'"
            text
            :disabled="!canSave"
            @click="EditAddress"
          >
            {{ 'Сохранить' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import WBDAutocompleteSearch from '@/components/common/autocomplete/index.vue'

export default {
  name: 'EditAddressForm',
  components: { WBDAutocompleteSearch },
  props: {
    modalEnabled: {
      type: Boolean,
      default: false,
    },
    saveCallback: {
      type: Function,
    },
    model: {
      type: Object,
    }
  },
  data: () => ({
    keyUpTargetId: 'managerUserFilterRef',
    address: {
      id: null,
      uri: null,
      fullAddress: null,
      originalAddress: null,
    },
    requesting: false,
    addressError: false,
  }),
  computed: {
    getOriginalAddress () {
      const { description } = this.model
      if (!!description && description.trim().length > 0) {
        return description
      }
      return null
    },
    getCurrentAddress () {
      const { location } = this.model
      this.appLogger.log(location, 'locaton')
      if (!location) {
        return null
      }
      const { address } = location

      if (!!address && address.trim().length > 0) {
        return address
      }
      return null
    },
    getTitle () {
      return 'Изменение адреса объекта'
    },
    getAddressSearchValue () {
      if (!this.address) {
        return undefined
      }

      return {
        id: 'office-id',
        title: this.address,
      }
    },
    canSave () {
      return !this.requesting && !!this.address.uri
    },
  },
  async created () {
    this.appLogger.log(this.model)
  },
  mounted () {
    window.addEventListener('keyup', (event) => {
      if (!(event && event.target && event.target.id === this.keyUpTargetId)) {
        return
      }
      if (event.keyCode === 13) {
        event.preventDefault()
        this.EditAddress()
      }
    })
  },
  methods: {
    async close () {
      this.$emit('EditAddressFormClosed')
    },
    async EditAddress () {
      const payload = {
        office: { id: this.model.id },
        address: this.address.originalAddress,
        uri: this.address.uri,
      }
      try {
        this.requesting = true
        await this.$store.dispatch(
          'organization/updateOfficeAddress',
          payload
        )
        this.appLogger.log(payload, 'payload')
        this.showSuccessNotification('Адрес объекта успешно обновлен')
        this.$emit('EditAddressFormSuccess', true)
      } catch (error) {
        this.showErrorNotification('Ошибка при измени адреса объекта')
        console.log(error)
        return null
      } finally {
        this.requesting = false
      }
    },
    onAddressChange (data) {
      this.address = data
      console.log(data)
    },
  }
}
</script>
